import * as React from 'react';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { reduxForm, InjectedFormProps, change } from 'redux-form';
import * as c from 'models/constants';
import { IMagazinePageSection } from 'models/common/section';
import { IModalAction } from 'models/modal';
import { ISectionData } from 'models/common/sectiondata';
import { Modal, Button, ErrorSummary } from 'components';
import { ButtonsSection } from 'components/PortalStructure';
import { onCloseModalForm } from 'helpers/common';
import { getArticleTags } from 'redux/modules/magazine/article/managearticle';
require('components/Tabs/style.css');
require('./../../style.css');

interface IProps extends InjectedFormProps {
	currentFormValues: ISectionData;
	section: IMagazinePageSection;
	showHeaderCloseButton: boolean;
	index: number;
	baseUrl: string;
	articleTags: any;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	change: any;

	/* functions props */
	saveSection?: (form: IMagazinePageSection, index?: number) => void;
	showModal: (modalType: string, modalProps: any) => IModalAction;
	closeModal: () => IModalAction;
	t?: (key: string) => string;
	getArticleTags?: () => void;
}

interface IState {
	error: boolean;
	message: any;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class EditSectionType14Form extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			error: false,
			message: null,
		};

		this.onSubmit = this.onSubmit.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.setError = this.setError.bind(this);
		this.clearError = this.clearError.bind(this);
	}

	public componentDidMount() {
		this.props.getArticleTags();
	}

	private setError(error: any) {
		this.setState({
			error: true,
			message: error,
		});
	}

	private clearError() {
		this.setState({
			error: false,
			message: null,
		});
	}

	public onSubmit(form: IMagazinePageSection) {
		this.props.saveSection(form, this.props.index);
	}

	private closeModal() {
		onCloseModalForm(this.props.dirty, this.props.showModal, this.props.closeModal, this.props.t);
	}

	public render() {
		const { handleSubmit, t, showHeaderCloseButton } = this.props;
		const { error, message } = this.state;

		const errorSummaryProps = {
			error,
			message,
		};

		return (
			<Modal
				title="Magazine Tags"
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={this.closeModal}
				modalClass="pageSectionManageWrapper"
			>
				<form onSubmit={handleSubmit(this.onSubmit)}>
					<div>
						<ErrorSummary {...errorSummaryProps} />
					</div>

					{
						this.props?.articleTags.length !== 0 ? (
							<div>
								{this.props.articleTags.map((tag) => {
									return <div key={tag.key}>{tag.value}</div>;
								})}
							</div>
						) : (
							<div>No tags found</div>
						) // translate
					}

					<ButtonsSection>
						<div className="row">
							<div className="col-sm-12">
								<Button type="submit" usage="admin" disabled={this.props?.articleTags.length !== 0 ? false : true}>
									{t('BSPortal_Common_Save')}
								</Button>
							</div>
						</div>
					</ButtonsSection>
				</form>
			</Modal>
		);
	}
}

function mapStateToProps(state, ownProps: IProps) {
	// Filtered by magazine page language
	const filteredArticleTags = state.manageArticle.articleTags.filter((tag) => {
		return tag.languageKey === state.menuItem.menuItem.languageKey;
	});

	const newProps = {
		type: c.MAGAZINE_PAGE_SECTION_TYPE_14,
		data: {
			elements: [
				{
					articleTags: filteredArticleTags,
				},
			],
		},
	};

	let currentFormValues: any = null;
	if (
		state.form[c.FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION14] &&
		state.form[c.FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION14].values
	) {
		currentFormValues = state.form[c.FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION14].values.data;
	}

	return {
		initialValues: newProps || ownProps.section, // take new values first
		currentFormValues,
		articleTags: filteredArticleTags,
	};
}

let ManageType14 = reduxForm(
	{
		form: c.FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION14,
		enableReinitialize: true,
	},
	mapStateToProps,
)(EditSectionType14Form);

ManageType14 = connect(mapStateToProps, (dispatch) => ({
	change: (field: string, value: string) => dispatch(change(field, value)),
	getArticleTags: () => dispatch(getArticleTags()),
}))(ManageType14);

export { ManageType14 };
